import ProjectionBodyInsights from "./ProjectionBodyInsights";

export default ProjectionBodyInsights;
